import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BuukdLogo } from "@/components/brand/BuukdLogo";
import { Sheet, SheetClose, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { isNativeApp, isNativeIosApp } from "@/lib/platform";

export function PublicHeader() {
  const isNativeIos = isNativeIosApp();
  const isNative = isNativeApp();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border ios-safe-top">
      <div className="container-app">
        <div className="flex items-center justify-between h-16">
          {/* Logo — from public folder, root-relative so it works from any route */}
          <BuukdLogo to="/" />

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              Home
            </Link>
            <Link
              to="/discover"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              Explore
            </Link>
            <Link
              to="/solutions"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              Our Solutions
            </Link>
            {!isNativeIos && (
              <Link
                to="/pricing"
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              >
                Pricing
              </Link>
            )}
            <Link
              to="/faq"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              FAQ
            </Link>
            <Link
              to="/signin"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              Sign in
            </Link>
          </nav>

          {/* CTA */}
          <div className="flex items-center gap-3">
            {/* Mobile menu */}
            <div className="md:hidden">
              <Sheet>
                <SheetTrigger asChild>
                  <Button variant="ghost" size="icon" aria-label="Open menu">
                    <Menu className="h-5 w-5" />
                  </Button>
                </SheetTrigger>
                <SheetContent side="right" className="w-[320px] sm:w-[360px]">
                  <SheetHeader>
                    <SheetTitle>Menu</SheetTitle>
                  </SheetHeader>
                  <div className="mt-6 grid gap-3">
                    <SheetClose asChild>
                      <Link
                        to="/"
                        className="rounded-lg border border-border bg-background px-4 py-3 text-sm font-medium text-foreground hover:bg-accent transition-colors"
                      >
                        Home
                      </Link>
                    </SheetClose>
                    <SheetClose asChild>
                      <Link
                        to="/discover"
                        className="rounded-lg border border-border bg-background px-4 py-3 text-sm font-medium text-foreground hover:bg-accent transition-colors"
                      >
                        Explore
                      </Link>
                    </SheetClose>
                    <SheetClose asChild>
                      <Link
                        to="/solutions"
                        className="rounded-lg border border-border bg-background px-4 py-3 text-sm font-medium text-foreground hover:bg-accent transition-colors"
                      >
                        Our Solutions
                      </Link>
                    </SheetClose>
                    {!isNativeIos && (
                      <SheetClose asChild>
                        <Link
                          to="/pricing"
                          className="rounded-lg border border-border bg-background px-4 py-3 text-sm font-medium text-foreground hover:bg-accent transition-colors"
                        >
                          Pricing
                        </Link>
                      </SheetClose>
                    )}
                    <SheetClose asChild>
                      <Link
                        to="/faq"
                        className="rounded-lg border border-border bg-background px-4 py-3 text-sm font-medium text-foreground hover:bg-accent transition-colors"
                      >
                        FAQ
                      </Link>
                    </SheetClose>
                    <SheetClose asChild>
                      <Link
                        to="/signin"
                        className="rounded-lg border border-border bg-background px-4 py-3 text-sm font-medium text-foreground hover:bg-accent transition-colors"
                      >
                        Sign in
                      </Link>
                    </SheetClose>
                    {!isNative && (
                      <SheetClose asChild>
                        <Link to="/signup">
                          <Button variant="gradient" className="w-full" size="pill">
                            Get Started
                          </Button>
                        </Link>
                      </SheetClose>
                    )}
                  </div>
                </SheetContent>
              </Sheet>
            </div>
            {!isNative && (
              <Button asChild variant="gradient" size="pill" className="hidden sm:flex">
                <Link to="/signup">Get Started</Link>
              </Button>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
